module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Light.78e4a00e.woff";